module.exports = __webpack_public_path__ + "static/media/microsoft.3e4cda21.svg";